import React from 'react'
import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { useUserManager } from '../../ng-compat/hooks'
import { PERMISSIONS } from '../../constants'
import { getFeatureFromCache } from '../../util/feature-cache'
import { SpecialOrderProductToast } from './SpecialOrderProductToast'

const tContext = 'Toast notification for special order product'

/**
 * Hook to show toast notification for special order products when sale completed
 * If user has permission, the toast includes a link to special order page
 */
export const useSpecialOrderProductToast = () => {
  const t = useT()
  const userManager = useUserManager()

  const specialOrderProductToast = (numOfSpecialOrderProducts: number) => {
    const ffSpecialOrder = getFeatureFromCache('inventory_special_orders')
    if (!ffSpecialOrder) return
    if (numOfSpecialOrderProducts < 1) return

    let message = ''
    let linkMessage = ''

    if (userManager.hasPermission(PERMISSIONS.SPECIAL_ORDER)) {
      message = t(
        '{numOfSpecialOrderProducts, plural, one {Special order product included in sale.} other {Special order products included in sale.}}',
        {
          numOfSpecialOrderProducts,
          _context: tContext,
        }
      )
      linkMessage = t('View special order page', {
        _context: tContext,
      })
    } else {
      message = t(
        '{numOfSpecialOrderProducts, plural, one {Special order product included in sale} other {Special order products included in sale}}',
        {
          numOfSpecialOrderProducts,
          _context: tContext,
        }
      )
    }

    ToastNotifications.success(
      <SpecialOrderProductToast message={message} linkMessage={linkMessage} />
    )
  }

  return specialOrderProductToast
}
